import { Component, inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subject } from 'rxjs';
import { debounceTime, filter, takeUntil } from 'rxjs/operators';
import { ListUsersFacade } from '../../../../../Facades/list-users.facade';
import { COMMON_IMPORTS } from '../../../../Shared/common-imports';
import { UsersTableComponent } from '../../Partials/users-table/users-table.component';
import { PERMISSIONS } from '../../../../../Enums/permission.enum';
import { AuthService } from '../../../../Shared/Services/auth.service';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
  selector: 'av-users-management',
  imports: [COMMON_IMPORTS, UsersTableComponent],
  templateUrl: './users-management.component.html',
  styleUrls: ['./users-management.component.scss', '../../../../../../assets/theme/cutom/_error-container.scss'],
})
export class UsersManagementComponent {
  private readonly _authService = inject(AuthService);


  readonly currentUser = toSignal(this._authService.currentUser$, { initialValue: null });
  
  readonly facade = inject(ListUsersFacade);

  searchControl = new FormControl<string>('');

  permissions = PERMISSIONS;

  private readonly destroy$ = new Subject<void>();

  constructor() {
    this.initSearch();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  initSearch(): void {
    this.searchControl
      .valueChanges.pipe(
        debounceTime(500),
        filter((value: string | null) => value !== null && (value.length === 0 || value.length >= 2)),
        takeUntil(this.destroy$)
      )
      .subscribe((value: string | null) => {
        this.facade.setSearchTerm(value ?? '');
      });
  }
}